module.exports = __webpack_public_path__ + "media/images/sprite-main-0e848975a70ac11ecada6de611d576eb.svg";